<template>
  <div class="log pb-2">
    <v-btn
      :disabled="customerStatus == 'view'"
      click.stop="dialog = false"
      @click="open()"
      class="payy-ass-btn green-button ready_pay"
      target="_blank"
    >
      Edit
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="34rem"
      persistent
      content-class="job-documents-dialog"
    >
      <v-form
        ref="form"
        onsubmit="return false;"
        v-model="valid"
        lazy-validation
      >
        <v-card class="comments-view job-documents-dialog-card pod-dialog-card">
          <v-toolbar fixed flat class="pod-dialog-toolbar">
            <v-toolbar-title>Edit Proof of Delivery</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="pod-dialog-close"
              :disabled="processing"
              @click.prevent="close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <v-spacer class="pod-dialog-body">
            <v-card-text class="nospace pod-dialog-content">
              <v-container class="p-16 pod-dialog-form">
                <div
                  class="pod-dialog-upload-row"
                  v-if="documents.length < 30"
                >
                  <div class="upload-btn-wrapper">
                    <button
                      type="button"
                      class="btn pod-dialog-upload-btn"
                    >
                      + Upload
                    </button>
                    <input
                      ref="fileUpload"
                      id="fileUpload"
                      type="file"
                      multiple
                      accept=".pdf, .jpeg, .jpg, .png"
                      @change="uploadDocument"
                    />
                  </div>
                </div>
                <v-text-field
                  v-if="documents.length"
                  v-model="comments"
                  class="pt-0 currencyTitle pod-dialog-description"
                  placeholder="Description"
                  single-line
                  hide-details
                  :rules="[rules.noWhiteSpace, rules.required]"
                ></v-text-field>
                <ul class="pod-dialog-file-list" v-if="documents.length">
                  <li
                    :key="i"
                    v-for="(doc, i) in documents"
                    class="list pod-dialog-file-item"
                    ref="documentList"
                  >
                    <button
                      type="button"
                      class="pod-dialog-file-remove"
                      @click="removeImage(i)"
                    >
                      <span class="close imageClose">&times;</span>
                    </button>
                    <a
                      :href="doc"
                      class="document-link"
                      v-if="doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'"
                      target="_blank"
                    >
                      <img src="../../assets/pfd.png" />
                    </a>
                    <a
                      :href="doc"
                      class="document-link"
                      target="_blank"
                      v-else
                    >
                      <img
                        src="../../assets/docimg.webp"
                        height="72"
                        width="75"
                      />
                    </a>
                  </li>
                </ul>
              </v-container>
            </v-card-text>

            <v-card-actions class="pod-dialog-actions">
              <v-snackbar
                :timeout="3000"
                bottom
                color="red darken-2"
                v-model="x.error"
                class="white--text"
                v-if="x.error"
                >{{ x.error }}</v-snackbar
              >
              <v-spacer></v-spacer>
              <v-btn
                class="pod-dialog-cancel-btn oms-dialog-action--secondary"
                :disabled="processing"
                depressed
                @click="close"
                >Close</v-btn
              >
              <v-btn
                class="pod-dialog-submit-btn oms-dialog-action--primary"
                :disabled="processing"
                depressed
                @click="editProofOfDelivery()"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-spacer>
        </v-card>
      </v-form>
    </v-dialog>
    <success-dialog
      content="The proof of additional charge has been uploaded successfully"
      :show="x.success"
      :onclose="() => (x.success = false)"
    />
  </div>
</template>
<script>
import moment from "moment";
import { addProofOfDelivery, uploadImage } from "@/constants/api-urls.js";
import SuccessDialog from "@/components/Common/SuccessDialog";
import { StorageKeys } from "../../constants/constants";
export default {
  data() {
    return {
      AssignmentId: [],
      customerStatus: "",
      ids: "",
      currency: "",
      valid: true,
      lazy: false,
      type: "",
      comments: "",
      documents: [],
      x: {
        error: null,
        success: false,
      },
      amount: null,
      comments: null,
      items: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "This field is required.",
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  props: {
    details: Object,
    assId: String,
  },
  created() {
    // this.getActivityLog();
    this.customerStatus = localStorage.getItem("cust-status");
  },
  components: {
    SuccessDialog,
  },
  methods: {
    open() {
      this.dialog = true;
      this.documents = [...this.details.document];
      this.comments = this.details.description;
    },
    removeImage(key) {
      this.documents.splice(key, 1);
    },
    close() {
      this.dialog = false;
      this.documents = [];
      (this.type = ""), (this.comments = "");
      this.$refs.form.resetValidation();
    },
    uploadDocument(e) {
      this.error = null;
      var files = e.target.files || e.dataTransfer.files;
      let x = [...files];
      setTimeout(() => {
        this.$refs.fileUpload.value = "";
      }, 6000);
      if (!files.length) return;

      Array.from(x).forEach((y, i) => {
        this.createImage(files[i]);
      });
    },
    createImage(file) {
      let size = file.size / 1024 / 1024;
      // -------- FILE SIZE CHECK
      if (size > 5) {
        this.x.error = "Please upload proof with size less than 5MB!";

        return false;
      }
      if (
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/png" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpeg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !==
          "application/pdf"
      ) {
        this.x.error =
          "Please upload proof of file type png , jpg ,jpeg or pdf!";
        return false;
      } else {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = (e) => {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.upload(file);
      }
    },
    upload(file) {
      this.processing = true;
      const formData = new FormData();
      formData.append("image", file);
      this.axios({
        url: `${this.constants.apiUrl}${uploadImage}`,
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(
        (response) => {
          this.processing = false;
          const { statusCode } = response.data;
          if (statusCode === 200) {
            if (this.documents.length < 30) {
              this.documents.push(response.data.data.original);
            } else {
              this.x.error = "Maximum 30 proofs can be uploaded!";
              return false;
            }
          } else {
            this.x.error = "Failed to upload image";
          }
          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to upload image";
          this.processing = false;
        }
      );
    },
    editProofOfDelivery() {
      if (this.processing) {
        return;
      }

      if (!this.documents.length) {
        this.x.error = "Please upload proof of delivery document";
        this.processing = false;
        this.loading = false;
        return false;
      }
      if (this.$refs.form.validate()) {
        this.processing = true;
        let url = "/dmsAdmin/editProofOfDeliveryForAssignment";
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          assignmentId: this.assId,
          id: this.details._id,
          document: this.documents,
          comment: this.comments,
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.documents = [];
            this.$refs.fileUpload.value = "";
            this.processing = false;
            this.close();

            this.$eventBus.$emit("delivery-proof-dialog");
          },
          (error) => {
            this.processing = false;
            this.x.error = error.response.data.message;
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}
.document-link {
  text-decoration: none;
}
.ttt button select {
  border: none !important;
}
.imageClose {
  align-items: center;
  background: #d92d20;
  border-radius: 50%;
  color: #fff !important;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  line-height: 1;
  position: static;
  width: 18px;
}

.list {
  display: inline-block;
  position: relative;
}

.pod-dialog-card {
  background: var(--oms-surface, #ffffff) !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  border-radius: 12px !important;
}

.pod-dialog-toolbar {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-bottom: 1px solid var(--oms-border, #e4e1d9) !important;
  min-height: 56px;
}

.pod-dialog-toolbar ::v-deep .v-toolbar__content {
  padding: 0 18px !important;
}

.pod-dialog-toolbar ::v-deep .v-toolbar__title {
  color: #172033 !important;
  font-size: 16px !important;
  font-weight: 800;
  letter-spacing: 0 !important;
}

.pod-dialog-close {
  background: transparent !important;
  box-shadow: none !important;
  color: var(--oms-ink, #3a382f) !important;
}

.pod-dialog-close ::v-deep .v-icon {
  color: var(--oms-ink, #3a382f) !important;
}

.pod-dialog-body {
  display: block;
}

.pod-dialog-content {
  min-height: 136px;
  padding: 0 !important;
}

.pod-dialog-form {
  max-width: 100%;
  padding: 20px 18px 12px !important;
  width: 100%;
}

.pod-dialog-upload-row {
  align-items: flex-start !important;
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
}

.pod-dialog-description {
  margin-top: 12px !important;
  width: 100%;
}

.pod-dialog-card ::v-deep .v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.pod-dialog-card ::v-deep .v-text-field .v-input__control {
  min-height: 42px;
}

.pod-dialog-card ::v-deep .v-text-field .v-input__slot {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  min-height: 42px !important;
  padding: 0 12px !important;
}

.pod-dialog-card ::v-deep .v-text-field .v-input__slot::before,
.pod-dialog-card ::v-deep .v-text-field .v-input__slot::after {
  display: none !important;
}

.pod-dialog-card ::v-deep .v-text-field input {
  margin-top: 0 !important;
  padding: 8px 0 !important;
}

.pod-dialog-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  list-style: none;
  margin: 16px 0 0 !important;
  padding: 8px 0 0 !important;
}

.pod-dialog-file-item {
  display: inline-block;
  margin: 0;
  padding: 8px 4px 0;
  position: relative;
}

.pod-dialog-file-remove {
  background: transparent;
  border: 0;
  cursor: pointer;
  line-height: 0;
  padding: 0;
  position: absolute;
  right: -6px;
  top: -6px;
  z-index: 2;
}

.pod-dialog-actions {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-top: 1px solid var(--oms-border, #e4e1d9) !important;
  gap: 10px;
  justify-content: flex-end;
  padding: 14px 18px !important;
}

.pod-dialog-cancel-btn,
.pod-dialog-submit-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 38px !important;
  letter-spacing: 0 !important;
  min-width: 88px !important;
  text-transform: none !important;
}

.pod-dialog-cancel-btn {
  background: #ffffff !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.pod-dialog-submit-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  background-color: var(--oms-primary, #ea7a1c) !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.pod-dialog-submit-btn ::v-deep .v-btn__content {
  color: #ffffff !important;
}

.job-documents-dialog-card {
  border-radius: 10px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.job-documents-dialog-card .v-toolbar {
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa;
  color: #172033 !important;
}

.job-documents-dialog-card .v-toolbar__title {
  color: #172033 !important;
  font-size: 15px;
  font-weight: 900;
}

.job-documents-dialog-card .v-card__text {
  background: #ffffff;
  padding: 12px !important;
}

.job-documents-dialog-card .upload-btn-wrapper .btn {
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 8px !important;
  color: #a85510 !important;
  font-size: 12px;
  font-weight: 900;
  height: 42px;
  min-height: 42px;
  padding: 0 14px;
  white-space: nowrap;
}

.job-documents-dialog-card .document-link img {
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  height: 52px !important;
  object-fit: contain;
  padding: 6px;
  width: 52px !important;
}

.job-documents-dialog-card .v-card__actions {
  border-top: 1px solid #e4e7ec;
  padding: 10px 12px !important;
}

.job-documents-dialog-card .v-card__actions .v-btn {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}

.message {
  display: inline-block;
  margin: 0 50px;
}
.communication {
  width: 40%;
}
.success {
  font-size: 18px;
  font-weight: 600;
}
.messagebtn {
  margin: 0 auto;
}
.thumb {
  width: 80px;
  height: 80px;
}

.custom-file-upload {
  border: none;
  display: inline-block;
  background: #ea7a1c;
  font-size: 16px;
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
}
</style>

<style lang="css">
.application .job-documents-dialog .pod-dialog-submit-btn.v-btn,
.application .v-dialog .pod-dialog-submit-btn.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  background-color: var(--oms-primary, #ea7a1c) !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  box-shadow: 0 2px 8px rgba(234, 122, 28, 0.25) !important;
  color: #ffffff !important;
}

.application .job-documents-dialog .pod-dialog-submit-btn.v-btn .v-btn__content,
.application .v-dialog .pod-dialog-submit-btn.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .job-documents-dialog .pod-dialog-cancel-btn.v-btn,
.application .v-dialog .pod-dialog-cancel-btn.v-btn {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  box-shadow: none !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .job-documents-dialog .pod-dialog-cancel-btn.v-btn .v-btn__content,
.application .v-dialog .pod-dialog-cancel-btn.v-btn .v-btn__content {
  color: var(--oms-ink, #3a382f) !important;
}

.application .job-documents-dialog .pod-dialog-form .v-text-field .v-input__slot::before,
.application .job-documents-dialog .pod-dialog-form .v-text-field .v-input__slot::after,
.application .v-dialog .pod-dialog-form .v-text-field .v-input__slot::before,
.application .v-dialog .pod-dialog-form .v-text-field .v-input__slot::after {
  display: none !important;
}

.application .job-documents-dialog .pod-dialog-form .v-text-field .v-input__slot,
.application .v-dialog .pod-dialog-form .v-text-field .v-input__slot {
  background: #ffffff !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  min-height: 42px !important;
  padding: 0 12px !important;
}
</style>
